import { Trans } from '@lingui/macro';
import { Tabs, TabNav, TabContent, Tab } from '@pocketlaw/tetris';
import { useHistory, useParams } from 'react-router-dom';
import { useCompanyFeatures } from 'app/domains/companies';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { SettingTabsKeys } from '../../types';
import { Header } from './styled';
export function SettingsTabs(props) {
    const { children } = props;
    const history = useHistory();
    const { activeTab } = useParams();
    const { isFeatureAvailable } = useCompanyFeatures();
    const useApiManagement = isFeatureAvailable('web_api');
    const manageApiKeys = useFeatureFlag('feature_api_key_management');
    const apiAccess = useApiManagement && manageApiKeys;
    const handleSelect = (tabId) => {
        history.push(`/settings/${tabId}`);
    };
    return (<Tabs initialActiveTab="profile" activeTab={activeTab} onSelect={handleSelect}>
      <Header>
        <TabNav>
          <Tab id={SettingTabsKeys.Profile}>
            <Trans comment="Account tab - settings">Settings</Trans>
          </Tab>
          <Tab id={SettingTabsKeys.Plan}>
            <Trans comment="Account tab - packages & payment">Packages &amp; payment</Trans>
          </Tab>
          <Tab id={SettingTabsKeys.Esigning}>
            <Trans comment="Account tab - e-signing">E-signing</Trans>
          </Tab>
          {apiAccess && (<Tab id={SettingTabsKeys.Api}>
              <Trans comment="Account tab - api keys">Api keys</Trans>
            </Tab>)}
        </TabNav>
      </Header>

      <TabContent tabId={activeTab}>{children}</TabContent>
    </Tabs>);
}
